import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { requiredValidator } from '@scisys-uim/uim-common';
import { BusinessUnit, BUSINESS_UNIT_METADATA } from 'assets-model';
import { AssetsUserStorage, BusinessUnitService, TodolistEntry, TodolistService } from 'assets-service';

@Component({
  templateUrl: './todolist-add-dialog.component.html',
  styleUrls: ['./todolist-add-dialog.component.css']
})
export class TodolistAddDialogComponent {

  name: string;
  date: Date;
  description: string;
  businessUnit: BusinessUnit;
  national: boolean = false;

  public businessUnits: BusinessUnit[];

  nationalEnabled: boolean = false;

  form: FormGroup;

  constructor(private dialogRef: MatDialogRef<TodolistAddDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private todolistService: TodolistService,
    private businessUnitService: BusinessUnitService,
    private userDetailsStorage: AssetsUserStorage,
    private fb: FormBuilder) {
  }

  ngOnInit() {
    this.businessUnitLoadSelectionList();
    this.form = this.fb.group({
      name: [requiredValidator],
      date: [requiredValidator],
      description: [],
      businessUnit: [requiredValidator],
      national: []
    })
    this.userDetailsStorage.nextNonNullItem().subscribe(userDetails => {
      const businessUnit: BusinessUnit = userDetails ? userDetails.getDefaultBusinessUnit() : null;
      this.nationalEnabled = businessUnit?.type == "T";
    });
  }


  public closeDialog() {
    this.dialogRef.close();
  }

  public addEntry() {
    if (!this.name || !this.date) {
      return;
    }
    let entry = new TodolistEntry(this.name, this.date, this.description, this.businessUnit, this.national);
    this.todolistService.addEntry(entry).subscribe(
      response => {
        this.closeDialog();
        this.data.todolist.updateList();
      }
    );
  }

  nationalChanged(value: boolean, unsetDependents: boolean = true) {
    if (this.national) {
      this.businessUnit = this.businessUnits.find(d => d.type == 'T');
    }
  }

  businessUnitChanged(value: BusinessUnit, unsetDependents: boolean = true) {

  }

  businessUnitLoadSelectionList() {
    this.businessUnitService.findAll().subscribe(
      data => {
        this.businessUnits = data.items;
      }
    );
  }

  compareBusinessUnit(a: any, b: any) {
    return BUSINESS_UNIT_METADATA.equals(a, b);
  }
}
